(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fluff-brand-guide"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
     FLUFF BRAND GUIDE — reads the brand layer back out.

     Three jobs:
       1. print the resolved value of every --fluff-* token
       2. score swatch contrast so nobody guesses
       3. copy tokens to the clipboard on click

     Nothing here defines brand values. If a value looks wrong, edit
     Theme settings > Fluffmallows brand.
     ============================================================ */
  (() => {
    const TOKENS = [
      '--fluff-font-body',
      '--fluff-font-bubble',
      '--fluff-font-hand',
      '--fluff-pink',
      '--fluff-pink-dark',
      '--fluff-pink-mid',
      '--fluff-pink-soft',
      '--fluff-blush',
      '--fluff-blush-deep',
      '--fluff-ink',
      '--fluff-ink-dark',
      '--fluff-shadow',
      '--fluff-radius',
      '--fluff-radius-sm',
      '--fluff-control-height',
      '--fluff-divider',
    ];

    // Turn whatever the browser reports (rgb(), #hex, colour names) into a
    // plain [r, g, b] so contrast can be measured.
    const toRgb = (value) => {
      const probe = document.createElement('span');
      probe.style.cssText = `display:none;color:${value}`;
      document.body.appendChild(probe);
      const resolved = getComputedStyle(probe).color;
      probe.remove();
      const nums = resolved.match(/[\d.]+/g);
      return nums ? nums.slice(0, 3).map(Number) : null;
    };

    const toHex = (rgb) =>
      rgb ? `#${rgb.map((n) => Math.round(n).toString(16).padStart(2, '0')).join('')}`.toUpperCase() : '';

    // WCAG relative luminance, then the standard contrast ratio.
    const luminance = ([r, g, b]) =>
      [r, g, b]
        .map((c) => {
          const s = c / 255;
          return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
        })
        .reduce((acc, c, i) => acc + c * [0.2126, 0.7152, 0.0722][i], 0);

    const ratio = (a, b) => {
      const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
      return (hi + 0.05) / (lo + 0.05);
    };

    const say = (message) => {
      if (window.FluffTheme && typeof window.FluffTheme.toast === 'function') {
        window.FluffTheme.toast(message);
      }
    };

    const copy = (text, message) => {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(() => say(message)).catch(() => {});
    };

    const setup = (root) => {
      const rootStyle = getComputedStyle(document.documentElement);
      const read = (token) => rootStyle.getPropertyValue(token).trim();

      // 1. Swatches: resolved hex plus the text colour that passes on it.
      root.querySelectorAll('[data-fmbg-swatch]').forEach((chip) => {
        const rgb = toRgb(read(chip.dataset.fmbgSwatch));
        if (!rgb) return;

        const card = chip.closest('.fmbg-swatch');
        const hexLabel = card && card.querySelector('[data-fmbg-hex]');
        if (hexLabel) hexLabel.textContent = `${chip.dataset.fmbgSwatch} · ${toHex(rgb)}`;

        const onWhite = ratio(rgb, [255, 255, 255]);
        const onInk = ratio(rgb, toRgb(read('--fluff-ink-dark')) || [76, 76, 76]);
        const best = onWhite >= onInk ? onWhite : onInk;
        const badge = chip.querySelector('[data-fmbg-contrast]');
        if (badge) {
          const grade = best >= 4.5 ? 'AA' : best >= 3 ? 'AA lg' : 'deco';
          badge.textContent = `${best.toFixed(1)}:1 ${grade}`;
          badge.title = `Best pairing: ${onWhite >= onInk ? 'white' : 'ink dark'} text`;
        }
      });

      // 2. Type specimens report the size the browser actually computed.
      root.querySelectorAll('[data-fmbg-measure]').forEach((sample) => {
        const meta = sample.parentElement && sample.parentElement.querySelector('[data-fmbg-size]');
        if (!meta) return;
        const style = getComputedStyle(sample);
        meta.textContent = `${Math.round(parseFloat(style.fontSize))}px / ${style.fontWeight}`;
      });

      // 3. The token table.
      const table = root.querySelector('[data-fmbg-tokens]');
      if (table) {
        const rows = TOKENS.map((token) => {
          const value = read(token);
          const isColour = /^(--fluff-(pink|blush|ink))/.test(token);
          return `<div class="fmbg-token-row">
            <span class="fmbg-token-dot" style="${isColour ? `background:${value}` : 'background:transparent;box-shadow:none'}"></span>
            <span class="fmbg-token-name">${token}</span>
            <span class="fmbg-token-value">${value.replace(/</g, '&lt;')}</span>
          </div>`;
        });
        table.innerHTML = rows.join('');

        const copyAll = root.querySelector('[data-fmbg-copy-tokens]');
        if (copyAll) {
          copyAll.addEventListener('click', () => {
            const block = TOKENS.map((t) => `  ${t}: ${read(t)};`).join('\n');
            copy(`:root {\n${block}\n}`, 'Tokens copied');
          });
        }
      }

      // 4. Click-to-copy on swatches, and the toast demo.
      root.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-fmbg-copy]');
        if (swatch) copy(swatch.dataset.fmbgCopy, `Copied ${swatch.dataset.fmbgCopy}`);

        if (event.target.closest('[data-fmbg-toast]')) {
          say('Added to your cart 🎉');
        }
      });
    };

    const init = () => document.querySelectorAll('[data-fluff-brand-guide]').forEach(setup);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-fluff-brand-guide]').forEach(setup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluff-card-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fluff-card-grid-carousel')) {
    class FluffCardGridCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fluff-card-grid-track]');
        this.cards = Array.from(this.querySelectorAll('[data-fluff-card-grid-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-fluff-card-grid-dot]'));

        if (!this.track || this.cards.length < 2) return;

        this.scrollFrame = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.track.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.updatePagination();
      }

      disconnectedCallback() {
        if (!this.track) return;

        this.track.removeEventListener('scroll', this.handleScroll);
        this.track.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updatePagination());
      }

      handleClick(event) {
        const dot = event.target.closest('[data-fluff-card-grid-dot]');
        if (!dot || !this.contains(dot)) return;

        this.scrollToCard(Number(dot.dataset.fluffCardGridDot));
      }

      handleKeydown(event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.scrollToCard(this.activeIndex() + direction);
      }

      handleBlockSelect(event) {
        const card = event.target.closest('[data-fluff-card-grid-card]');
        if (!card || !this.contains(card)) return;

        this.scrollToCard(this.cards.indexOf(card));
      }

      activeIndex() {
        if (!this.cards.length) return 0;

        let closestIndex = 0;
        let closestDistance = Infinity;
        const trackStart = this.track.getBoundingClientRect().left;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackStart);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      scrollToCard(index) {
        const safeIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const card = this.cards[safeIndex];
        if (!card) return;

        card.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }

      updatePagination() {
        const index = this.activeIndex();

        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('fluff-card-grid-carousel', FluffCardGridCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluff-globals"]) return;
  try {
    
  /* ============================================================
     FLUFFMALLOWS — site-wide behaviour (loaded on every page)

     Four jobs:
       1. the help menu behind the 💬 icon in the header
       2. opening "Build a Box" from any button, anywhere
       3. the image pop-up for gallery photos
       4. opening the cart drawer after something is added

     Kept separate from fluff-shared.liquid because that one only
     loads where a Fluff section is used; this loads everywhere.
     ============================================================ */
  (() => {
    // Create the shared namespace here as well as in the nearby inline
    // script. Shopify may schedule snippet JavaScript in a different order,
    // and this keeps initialization from stopping before click handlers exist.
    window.FluffTheme = window.FluffTheme || {};

    // Don't set up twice if this snippet is rendered more than once.
    if (window.FluffGlobalsReady) return;
    window.FluffGlobalsReady = true;

    // Short helpers: q = find one element, qa = find all of them.
    const q = (sel, root = document) => root.querySelector(sel);
    const qa = (sel, root = document) => [...root.querySelectorAll(sel)];

    // Small message pill at the bottom of the screen, ~3 seconds.
    const toast = (message) => {
      let el = q('.fluff-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'fluff-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        document.body.appendChild(el);
      }
      el.textContent = message;
      el.classList.add('is-visible');
      clearTimeout(el.hideTimer);
      el.hideTimer = setTimeout(() => el.classList.remove('is-visible'), 2800);
    };
    window.FluffTheme.toast = toast;

    /* ---------- 1. THE HELP MENU (💬 header icon) ----------
       A small menu that drops down from the header icon. Most of its
       links open a pre-addressed email; "Flavour assistant" jumps to
       the flavour map instead. Any button marked data-fluff-help opens
       it, so the footer can use it too. */
    const helpMenu = q('#fluff-help-menu');
    if (helpMenu) {
      helpMenu.hidden = false;

      // Move the menu so it hangs just under whichever button was used.
      const place = (btn) => {
        const r = btn.getBoundingClientRect();
        helpMenu.style.right = `${Math.max(8, innerWidth - r.right - 4)}px`;
        helpMenu.style.top = `${r.bottom + 14}px`;
      };

      document.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-fluff-help]');
        if (btn) {
          event.preventDefault();
          place(btn);
          helpMenu.classList.toggle('is-open');
          return;
        }
        // A click anywhere else closes it.
        if (!helpMenu.contains(event.target)) helpMenu.classList.remove('is-open');
      });

      // Escape closes it too.
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') helpMenu.classList.remove('is-open');
      });

      helpMenu.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) return;
        helpMenu.classList.remove('is-open');
        // If there's a flavour map on this page, scroll to it rather
        // than navigating away to the flavours page.
        const map = q('[data-fluff-map]');
        if (link.hasAttribute('data-fluff-help-link') && map) {
          event.preventDefault();
          map.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    /* ---------- 2. SITE-WIDE POP-UPS AND "BUILD A BOX" ----------
       Generic Fluff actions (quote, wholesale and named image pop-ups)
       use data-fluff-open="ID". Keep that wiring global so hero buttons
       do not depend on a section-scoped script having initialized first. */
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-fluff-open]')
        : null;
      if (!trigger) return;

      const target = trigger.dataset.fluffOpen;
      const dialog = document.getElementById(target)
        || [...document.querySelectorAll('[data-fluff-dialog]')]
          .find((candidate) => candidate.dataset.fluffDialog === target);
      if (!dialog) return;

      event.preventDefault();
      forceOpenDialog(dialog);
    });

    /* "BUILD A BOX" FROM ANY BUTTON
       Mark any button or link with data-fluff-build-box, or point a
       link at #build-a-box, and it opens the box builder pop-up.

       The full four-step builder is rendered globally, so this works on
       every template without requiring a box-builder page section. */
    function forceOpenDialog(dialog) {
      if (!dialog) return false;

      // A second open modal makes showModal throw. Close it first so a
      // Build a Box click always wins, then use the open attribute as a
      // fallback for browsers or theme scripts that interfere with dialog.
      qa('dialog[open]').forEach((openDialog) => {
        if (openDialog !== dialog && typeof openDialog.close === 'function') openDialog.close();
      });
      try {
        if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
      } catch (error) {
        dialog.setAttribute('open', '');
      }
      if (!dialog.open) dialog.setAttribute('open', '');
      return true;
    }

    const openBuildABox = () => {
      if (window.FluffBuildBox?.open) return window.FluffBuildBox.open();

      // If Shopify scheduled the builder's script after this one, ask it to
      // initialize now. The direct dialog fallback still guarantees a pop-up.
      document.dispatchEvent(new CustomEvent('fluff:open-build-box'));
      if (window.FluffBuildBox?.open) return true;
      return forceOpenDialog(q('#FluffGlobalBuildBox'));
    };
    window.FluffTheme.openBuildABox = openBuildABox;

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest('[data-fluff-build-box], a[href$="#build-a-box"], a[href$="#FluffBuilder"]')
        : null;
      if (!trigger) return;
      event.preventDefault();
      openBuildABox();
    });

    // Global builders can appear on templates that do not load any other
    // Fluff section, so their close button and backdrop are handled here too.
    document.addEventListener('click', (event) => {
      const close = event.target instanceof Element ? event.target.closest('[data-fluff-close]') : null;
      const dialog = close?.closest('dialog');
      if (dialog?.open) dialog.close();
      if (event.target instanceof HTMLDialogElement && event.target.open) event.target.close();
    });

    /* ---------- 3. IMAGE POP-UP (gallery photos) ----------
       Clicking anything marked data-fluff-lightbox shows that photo
       big, in the middle of the screen, with its caption underneath.
       The attribute holds the large version of the image. */
    const lightbox = q('#fluff-lightbox');
    if (lightbox) {
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-fluff-lightbox]');
        if (!trigger) return;
        event.preventDefault();
        const img = trigger.tagName === 'IMG' ? trigger : q('img', trigger);
        if (!img) return;
        const target = q('[data-fluff-lightbox-image]', lightbox);
        const caption = q('[data-fluff-lightbox-caption]', lightbox);
        // Prefer the big version; fall back to whatever is on screen.
        target.src = trigger.dataset.fluffLightbox || img.currentSrc || img.src;
        target.alt = img.alt || '';
        const text = trigger.dataset.fluffCaption || '';
        caption.textContent = text;
        caption.hidden = !text;
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
      });
    }

    /* ---------- 4. AFTER ADDING TO CART ----------
       When something is added, slide the cart drawer open and give the
       newest line a little pop, the way the prototype does. */

    // Briefly animates the top line item in the drawer.
    const flashNewLineItem = () => {
      requestAnimationFrame(() => {
        const item = q('#cart-drawer .cart-item');
        if (!item) return;
        item.classList.add('fluff-just-added');
        setTimeout(() => item.classList.remove('fluff-just-added'), 700);
      });
    };

    // Themes open their cart drawer in different ways, so try the
    // usual ones in turn and, failing all of them, just click the
    // cart button in the header.
    const openCartDrawer = () => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      if (typeof drawer.showDialog === 'function') drawer.showDialog();
      else if (typeof drawer.open === 'function') drawer.open();
      else {
        const dialog = drawer.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
        else q('[data-testid="cart-drawer-trigger"]')?.click();
      }
    };

    // Small delay so the theme has finished refreshing the drawer's
    // contents before we open it and animate the new line.
    document.addEventListener('fluff:cart-added', () => {
      setTimeout(() => { openCartDrawer(); flashNewLineItem(); }, 60);
    });

    /* Reveal-on-scroll for stock theme sections is pure CSS — add the
       class `fluff-reveal` to any element to give it the rise-in. */
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluff-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fluff-reviews-carousel')) {
    class FluffReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fluff-reviews-track]');
        this.cards = Array.from(this.querySelectorAll('[data-fluff-review-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-fluff-review-dot]'));

        if (!this.track || this.cards.length < 2 || this.dots.length < 2) return;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.track.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.updatePagination(0);
      }

      disconnectedCallback() {
        if (!this.track || !this.handleScroll) return;

        this.track.removeEventListener('scroll', this.handleScroll);
        this.track.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);

        if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
      }

      handleScroll() {
        if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);

        this.scrollFrame = window.requestAnimationFrame(() => {
          const step = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
          if (!step) return;

          const index = Math.min(
            this.cards.length - 1,
            Math.max(0, Math.round(this.track.scrollLeft / step))
          );
          this.updatePagination(index);
        });
      }

      handleClick(event) {
        const dot = event.target.closest('[data-fluff-review-dot]');
        if (!dot || !this.contains(dot)) return;

        this.scrollToReview(Number(dot.dataset.fluffReviewDot));
      }

      handleKeydown(event) {
        if (!window.matchMedia('(max-width: 900px)').matches) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const currentIndex = this.dots.findIndex((dot) => dot.getAttribute('aria-current') === 'true');
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const index = Math.min(this.cards.length - 1, Math.max(0, currentIndex + direction));
        this.scrollToReview(index);
      }

      handleBlockSelect(event) {
        const card = event.target.closest('[data-fluff-review-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.scrollToReview(index, 'auto');
      }

      scrollToReview(index, behavior) {
        const card = this.cards[index];
        if (!card) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({
          left: card.offsetLeft - this.cards[0].offsetLeft,
          behavior: behavior || (reduceMotion ? 'auto' : 'smooth')
        });
        this.updatePagination(index);
      }

      updatePagination(index) {
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('fluff-reviews-carousel', FluffReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fluff-shared"]) return;
  try {
    
  /* ============================================================
     FLUFF MALLOWS — shared behaviour for every Fluff section.

     Everything lives in one self-running function so nothing leaks
     into the global scope. It powers five things:
       1. the little "Added to your cart" message (toast)
       2. the flavour map: zoom, scroll and parallax
       3. the on-page box builder
       4. the step-by-step box builder dialog
       5. adding items to the real Shopify cart

     This snippet is rendered by several sections, but Shopify only
     includes the code once — and the guard on the first line stops
     it setting itself up twice.
     ============================================================ */
  (() => {
    // Already set up on this page? Then stop here.
    if (window.FluffMallowsComponents) return;

    // Short helpers: q = find one element, qa = find all of them.
    const q = (selector, root = document) => root.querySelector(selector);
    const qa = (selector, root = document) => [...root.querySelectorAll(selector)];

    // Shopify gives prices in cents (4200). Turn that into "CA$42.00".
    const money = (cents, currency = 'CAD') => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);

    // Shows a small pill at the bottom of the screen for ~3 seconds.
    // Re-uses the same element each time instead of stacking them up.
    const toast = (message) => {
      let el = q('.fm-toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'fm-toast';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        document.body.appendChild(el);
      }
      el.textContent = message;
      el.classList.add('is-visible');
      window.clearTimeout(el.hideTimer);
      el.hideTimer = window.setTimeout(() => el.classList.remove('is-visible'), 2800);
    };
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motionSelector = '[data-fluff-motion="true"][data-fluff-reveal], [data-fluff-motion="true"] [data-fluff-reveal]';
    const motionObserver = !reducedMotion && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('fluff-motion-visible');
            motionObserver.unobserve(entry.target);
          });
        }, { threshold: .12, rootMargin: '0px 0px -7% 0px' })
      : null;

    const reveal = (root = document) => {
      document.documentElement.classList.add('fluff-motion-ready');
      const targets = qa(motionSelector, root);
      if (root instanceof Element && root.matches(motionSelector)) targets.unshift(root);
      targets.forEach((target, index) => {
        target.style.setProperty('--fluff-motion-delay', `${Math.min(index * .08, .4)}s`);
        if (motionObserver) motionObserver.observe(target);
        else target.classList.add('fluff-motion-visible');
      });
    };

    /* ---------- THE FLAVOUR MAP ----------
       Sets up each flavour map's centred mobile viewport and zoom
       controls. Its background and Fluff Pops share one canvas, so their
       visual relationship never changes. */
    const setupMap = (root = document) => {
      qa('[data-fluff-map]:not([data-fluff-ready])', root).forEach((map) => {
        map.dataset.fluffReady = 'true';

        // The visible window, the part that scrolls, and the unified
        // background-and-pop canvas.
        const stage = q('.fm-map-stage', map);
        const scroller = q('.fm-map-scroller', map);
        const world = q('.fm-map-world', map);
        if (!stage || !scroller || !world) return;

        /* ---- ZOOM ----
           Zoom is just a number stored in the CSS variable --fm-zoom.
           1 = whole map visible, 3 = three times bigger. The CSS grows
           the map to match, which makes the area scrollable. */
        const startZoom = Number(getComputedStyle(map).getPropertyValue('--fm-zoom')) || 1;
        let zoom = startZoom;
        const MIN = 1;  // never smaller than "whole map fits"
        const MAX = 3;  // never more than 3x
        const isMobileMap = () => matchMedia('(max-width: 680px)').matches;
        const centredScrollLeft = () => Math.max(0, (scroller.scrollWidth - scroller.clientWidth) / 2);

        // Phones open on the centre of the larger canvas, with room to
        // swipe in either direction instead of seeing a compressed map.
        requestAnimationFrame(() => {
          if (isMobileMap()) scroller.scrollLeft = centredScrollLeft();
        });

        // Changes the zoom level, then re-scrolls so the spot the visitor
        // was looking at (the centre, or wherever they pointed) stays put
        // instead of the map jumping away under them.
        const applyZoom = (next, focal) => {
          const previous = zoom;
          zoom = Math.min(MAX, Math.max(MIN, Number(next.toFixed(2))));
          if (zoom === previous) return;
          const rect = scroller.getBoundingClientRect();
          // Where that spot currently sits inside the whole map.
          const cx = (focal ? focal.x - rect.left : rect.width / 2) + scroller.scrollLeft;
          const cy = (focal ? focal.y - rect.top : rect.height / 2) + scroller.scrollTop;
          const scale = zoom / previous;
          map.style.setProperty('--fm-zoom', String(zoom));
          // Wait one frame for the CSS to resize, then scroll to match.
          requestAnimationFrame(() => {
            scroller.scrollLeft = cx * scale - (focal ? focal.x - rect.left : rect.width / 2);
            scroller.scrollTop = cy * scale - (focal ? focal.y - rect.top : rect.height / 2);
          });
        };

        // The + / Fit / − buttons sitting on the map.
        map.addEventListener('click', (event) => {
          const button = event.target.closest('[data-map-zoom]');
          if (!button) return;
          const action = button.dataset.mapZoom;
          if (action === 'in') applyZoom(zoom + 0.25);
          if (action === 'out') applyZoom(zoom - 0.25);
          if (action === 'reset') {
            zoom = MIN;
            map.style.setProperty('--fm-zoom', String(MIN));
            requestAnimationFrame(() => {
              scroller.scrollTo({ left: isMobileMap() ? centredScrollLeft() : 0, top: 0, behavior: 'smooth' });
            });
          }
        });
        // Ctrl/⌘ + scroll wheel, and pinch-zoom on a trackpad, also zoom.
        // (Browsers report a pinch as a wheel event with ctrlKey set.)
        scroller.addEventListener('wheel', (event) => {
          if (!event.ctrlKey && !event.metaKey) return;
          event.preventDefault(); // stop the browser zooming the whole page
          applyZoom(zoom + (event.deltaY < 0 ? 0.2 : -0.2), { x: event.clientX, y: event.clientY });
        }, { passive: false });

      });
    };
    /* ---------- THE ON-PAGE BOX BUILDER ----------
       The "Build Your Box" section: pick a base, pick a box size, then
       tap flavours to fill the box picture on the right.

       The section's Liquid writes its bases, sizes and flavours into a
       hidden JSON block; this reads that, keeps track of what the
       shopper has chosen, and redraws the screen after every tap. */
    const setupBuilder = (root = document) => {
      qa('[data-fluff-builder]:not([data-fluff-ready])', root).forEach((section) => {
        section.dataset.fluffReady = 'true';

        // Read the choices the Theme Editor set up for this section.
        const dataEl = q('[data-fluff-builder-data]', section);
        if (!dataEl) return;
        let data;
        try { data = JSON.parse(dataEl.textContent); } catch { return; }
        if (!data.sizes.length || !data.bases.length) return;

        // What the shopper has chosen so far. "slots" is simply a list
        // of flavour ids, one entry per pop in the box.
        const state = { base: data.bases[0].name, size: data.sizes[0].count, slots: [] };

        // Turns that list into a tally, e.g. { smores: 3, cookie: 2 }.
        const counts = () => state.slots.reduce((all, id) => ({ ...all, [id]: (all[id] || 0) + 1 }), {});
        const activeSize = () => data.sizes.find((size) => size.count === state.size);

        // Redraws everything from `state`: which buttons look selected,
        // the flavour list, the pops in the box, the tally, the progress
        // bar, and whether Add to cart is allowed yet.
        const render = () => {
          qa('[data-builder-base]', section).forEach((button) => {
            const selected = button.dataset.builderBase === state.base;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
          qa('[data-builder-size]', section).forEach((button) => {
            const selected = Number(button.dataset.builderSize) === state.size;
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
          const tally = counts();

          // Only show flavours made on the chosen base — a box can't
          // mix vanilla and strawberry marshmallow.
          const flavours = data.flavours.filter((flavour) => flavour.base === state.base);
          q('[data-builder-flavours]', section).innerHTML = flavours.map((flavour) => `<button type="button" class="fm-flavour ${tally[flavour.id] ? 'is-selected' : ''}" data-builder-flavour="${flavour.id}" aria-label="Add ${flavour.name}">${tally[flavour.id] ? `<b class="fm-flavour-count">×${tally[flavour.id]}</b>` : ''}${flavour.image ? `<img src="${flavour.image}" alt="">` : ''}<span>${flavour.name}</span></button>`).join('');

          const size = activeSize();

          // Lay the box picture out in a sensible grid for its size:
          // 6 pops = 3 across, 12 = 4 across, 24 = 6, 48 = 8.
          const columns = state.size <= 6 ? 3 : state.size <= 12 ? 4 : state.size <= 24 ? 6 : 8;
          const slots = q('[data-builder-slots]', section);
          slots.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
          // Each chosen pop is drawn in the box and can be clicked to
          // remove it. Uses the wrapped photo where one was supplied.
          slots.innerHTML = state.slots.map((id) => {
            const flavour = data.flavours.find((item) => item.id === id);
            const image = flavour.wrap || flavour.image;
            return `<button type="button" class="fm-box-slot" data-builder-remove="${id}" aria-label="Remove one ${flavour.name}">${image ? `<img src="${image}" alt="${flavour.name}">` : flavour.name}</button>`;
          }).join('');

          // The "3 × S'mores Please" list under the box.
          q('[data-builder-summary]', section).innerHTML = data.flavours.filter((flavour) => tally[flavour.id]).map((flavour) => `<div class="fm-summary-item">${flavour.wrap || flavour.image ? `<img src="${flavour.wrap || flavour.image}" alt="">` : ''}<strong>${tally[flavour.id]}×</strong><span>${flavour.name}</span></div>`).join('');

          // Progress bar. Kept at 14% minimum so the "0/6" label still fits.
          const percent = Math.round(state.slots.length / state.size * 100);
          const bar = q('[data-builder-progress]', section);
          bar.style.width = `${Math.max(percent, 14)}%`;
          bar.textContent = `${state.slots.length}/${state.size}`;

          // "Choose 2 more Fluff Pops" or "Box complete — CA$36.00".
          q('[data-builder-hint]', section).textContent = state.slots.length === state.size ? `Box complete — ${money(size.price, data.currency)}` : `Choose ${state.size - state.slots.length} more Fluff Pop${state.size - state.slots.length === 1 ? '' : 's'}`;

          // Only allow Add to cart on a full box of an in-stock size.
          q('[data-builder-add]', section).disabled = state.slots.length !== state.size || !size.available;
        };

        // One click handler for the whole section. It works out which
        // kind of control was clicked, updates `state`, and redraws.
        section.addEventListener('click', async (event) => {
          // Changing base empties the box, since flavours can't carry over.
          const base = event.target.closest('[data-builder-base]');
          if (base) { if (state.base !== base.dataset.builderBase) { state.base = base.dataset.builderBase; state.slots = []; } render(); return; }

          // Changing size keeps what fits and drops the overflow.
          const size = event.target.closest('[data-builder-size]');
          if (size) { state.size = Number(size.dataset.builderSize); state.slots = state.slots.slice(0, state.size); render(); return; }

          // Clicking a pop in the box removes one of that flavour.
          const remove = event.target.closest('[data-builder-remove]');
          if (remove) { const index = state.slots.lastIndexOf(remove.dataset.builderRemove); if (index > -1) state.slots.splice(index, 1); render(); return; }

          // Clicking a flavour card adds one, until the box is full.
          const flavour = event.target.closest('[data-builder-flavour]');
          if (flavour) { if (state.slots.length < state.size) state.slots.push(flavour.dataset.builderFlavour); render(); return; }

          // Anything left is the Add to cart button.
          const add = event.target.closest('[data-builder-add]');
          if (!add) return;
          const sizeData = activeSize();
          const tally = counts();
          // The chosen base and flavours travel with the order as
          // line-item properties, so they show on the order in Shopify.
          const selection = data.flavours.filter((item) => tally[item.id]).map((item) => `${tally[item.id]}× ${item.name}`).join(', ');
          add.disabled = true; // stop double-clicks while it's saving
          try {
            await addCartItem(sizeData.variantId, 1, { 'Marshmallow base': state.base, 'Flavours': selection });
            state.slots = []; // empty the box, ready for another
            render();
          } catch (error) { toast(error.message || data.error); render(); }
        });
        render(); // first paint
      });
    };

    /* ---------- THE STEP-BY-STEP BUILDER DIALOG ----------
       The pop-up version of the same thing, walking through four steps:
       1 pick a size → 2 pick a base → 3 pick flavours → 4 review.

       It borrows the flavour/size/base data from the builder section on
       the page (`data-source` points at it) so there's only one list to
       keep up to date in the Theme Editor. */
    const setupWizard = (root = document) => {
      qa('[data-fluff-wizard]:not([data-fluff-ready])', root).forEach((dialog) => {
        dialog.dataset.fluffReady = 'true';
        const source = document.getElementById(dialog.dataset.source);
        const dataEl = source && q('[data-fluff-builder-data]', source);
        if (!dataEl) return;
        let data;
        try { data = JSON.parse(dataEl.textContent); } catch { return; }

        // Which step we're on and what's been picked so far.
        const state = { step: 1, size: null, base: null, counts: {} };
        const total = () => Object.values(state.counts).reduce((sum, count) => sum + count, 0);
        const selectedSize = () => data.sizes.find((item) => item.count === state.size);

        // Draws the current step into the dialog and sets the
        // Back/Next buttons appropriately.
        const render = () => {
          // Highlight the numbered dot for the current step.
          qa('[data-wizard-dot]', dialog).forEach((dot) => dot.classList.toggle('is-active', Number(dot.dataset.wizardDot) === state.step));
          const body = q('[data-wizard-body]', dialog);

          // Step 1 — the box sizes with their prices.
          if (state.step === 1) {
            body.innerHTML = `<h2 class="fm-dialog-title">Choose your box size</h2><div class="fm-choices">` + data.sizes.map((size) => `<button type="button" class="fm-choice ` + (size.count === state.size ? 'is-selected' : '') + `" data-wizard-size="` + size.count + `">` + size.label + `<small>` + money(size.price, data.currency) + `</small></button>`).join('') + `</div>`;
          }
          // Step 2 — the marshmallow bases.
          if (state.step === 2) {
            body.innerHTML = `<h2 class="fm-dialog-title">Choose a marshmallow base</h2><div class="fm-choices">` + data.bases.map((base) => `<button type="button" class="fm-choice ` + (base.name === state.base ? 'is-selected' : '') + `" data-wizard-base="` + base.name + `">` + base.name + `</button>`).join('') + `</div>`;
          }

          // Step 3 — a − / count / + row per flavour on the chosen base.
          // The + buttons switch off once the box is full.
          if (state.step === 3) {
            const remaining = state.size - total();
            const flavours = data.flavours.filter((flavour) => flavour.base === state.base);
            body.innerHTML = `<h2 class="fm-dialog-title">Select your flavours</h2><p class="fm-hint">` + (remaining ? `Choose ` + remaining + ` more Fluff Pop` + (remaining === 1 ? '' : 's') : 'Your box is full!') + `</p><div class="fm-wizard-flavours">` + flavours.map((flavour) => `<div class="fm-wizard-row">` + (flavour.image ? `<img src="` + flavour.image + `" alt="">` : '<span></span>') + `<strong>` + flavour.name + `</strong><span class="fm-wizard-controls"><button type="button" data-wizard-flavour="` + flavour.id + `" data-change="-1" ` + (state.counts[flavour.id] ? '' : 'disabled') + ` aria-label="Remove one">−</button><b>` + (state.counts[flavour.id] || 0) + `</b><button type="button" data-wizard-flavour="` + flavour.id + `" data-change="1" ` + (remaining ? '' : 'disabled') + ` aria-label="Add one">+</button></span></div>`).join('') + `</div>`;
          }
          // Step 4 — a summary of the box before it goes in the cart.
          if (state.step === 4) {
            const chosen = data.flavours.filter((flavour) => state.counts[flavour.id]).map((flavour) => `<li>` + state.counts[flavour.id] + `× ` + flavour.name + `</li>`).join('');
            const size = selectedSize();
            body.innerHTML = `<h2 class="fm-dialog-title">Review your Fluff Box</h2><p><strong>Box of ` + state.size + `</strong> — ` + state.base + ` base</p><ul>` + chosen + `</ul><p class="fm-heading fm-heading--medium">` + money(size.price, data.currency) + `</p>`;
          }
          // Hide Back on the first step, and don't let anyone move on
          // until the current step has actually been answered.
          const back = q('[data-wizard-back]', dialog);
          const next = q('[data-wizard-next]', dialog);
          back.style.visibility = state.step === 1 ? 'hidden' : 'visible';
          next.textContent = state.step === 4 ? 'Add to cart' : 'Next';
          next.disabled = (state.step === 1 && !state.size) || (state.step === 2 && !state.base) || (state.step === 3 && total() !== state.size);
        };

        // Handles taps on the choices inside the dialog. Changing the
        // size or base clears the flavours, because they may no longer fit.
        dialog.addEventListener('click', async (event) => {
          const size = event.target.closest('[data-wizard-size]');
          if (size) { state.size = Number(size.dataset.wizardSize); state.counts = {}; render(); return; }
          const base = event.target.closest('[data-wizard-base]');
          if (base) { state.base = base.dataset.wizardBase; state.counts = {}; render(); return; }

          // The − and + buttons; count never goes below zero.
          const flavour = event.target.closest('[data-wizard-flavour]');
          if (flavour) {
            const id = flavour.dataset.wizardFlavour;
            state.counts[id] = Math.max(0, (state.counts[id] || 0) + Number(flavour.dataset.change));
            if (!state.counts[id]) delete state.counts[id];
            render();
          }
        });
        // Back button.
        q('[data-wizard-back]', dialog).addEventListener('click', () => { if (state.step > 1) { state.step -= 1; render(); } });

        // Next button — on the last step this is the Add to cart action,
        // after which the dialog closes and resets for next time.
        q('[data-wizard-next]', dialog).addEventListener('click', async (event) => {
          if (state.step < 4) { state.step += 1; render(); return; }
          const size = selectedSize();
          const selection = data.flavours.filter((flavour) => state.counts[flavour.id]).map((flavour) => `${state.counts[flavour.id]}× ${flavour.name}`).join(', ');
          event.currentTarget.disabled = true;
          try {
            await addCartItem(size.variantId, 1, { 'Marshmallow base': state.base, 'Flavours': selection });
            dialog.close();
            state.step = 1; state.size = null; state.base = null; state.counts = {}; render();
          } catch (error) { toast(error.message || data.error); render(); }
        });
        render();
      });
    };

    /* ---------- ADDING TO THE SHOPIFY CART ----------
       Hands the item to fluff-cart.js. That module posts to Shopify and
       emits Horizon's native cart event with fresh drawer HTML, so the
       badge, items and totals update without a page refresh. `properties`
       is where custom box details ride along. */
    const addCartItem = async (variantId, quantity = 1, properties = {}) => {
      if (!variantId) throw new Error('Choose a Shopify product in the Theme Editor first.');

      // fluff-cart.js imports Horizon's native event classes. Wait briefly if
      // its module is still loading, then use its asynchronous cart bridge.
      // The timeout turns a failed module load into a readable error instead
      // of leaving the Add button spinning forever.
      if (!window.FluffCart?.addItem) {
        await Promise.race([
          new Promise((resolve) => document.addEventListener('fluff:cart-ready', resolve, { once: true })),
          new Promise((_, reject) => setTimeout(() => reject(new Error('The cart is still loading. Please try again.')), 5000)),
        ]);
      }
      const result = await window.FluffCart.addItem(variantId, quantity, properties);
      toast('Added to your cart');
      return result;
    };

    // Runs all the setup routines. Called on page load, and again when
    // the Theme Editor re-renders a section.
    const setup = (root = document) => { reveal(root); setupMap(root); setupBuilder(root); setupWizard(root); };

    /* ---------- SHARED CLICK HANDLERS ----------
       These listen on the whole page, so they keep working for markup
       added later (Theme Editor edits, re-rendered sections):
         data-fluff-open="ID"  → open that pop-up
         data-fluff-close      → close the pop-up you're inside
         data-fluff-add="ID"   → add that product to the cart */
    document.addEventListener('click', async (event) => {
      const open = event.target.closest('[data-fluff-open]');
      if (open) {
        const dialog = document.getElementById(open.dataset.fluffOpen) || q(`[data-fluff-dialog="${open.dataset.fluffOpen}"]`);
        if (dialog?.showModal && !dialog.open) dialog.showModal();
      }
      const close = event.target.closest('[data-fluff-close]');
      if (close) close.closest('dialog')?.close();
      const add = event.target.closest('[data-fluff-add]');
      if (add) {
        add.disabled = true; // guard against double taps
        try { await addCartItem(add.dataset.fluffAdd, Number(add.dataset.quantity || 1)); add.closest('dialog')?.close(); } catch (error) { toast(error.message); }
        add.disabled = false;
      }
    });

    /* The − / + quantity steppers in the order pop-ups. Updates the
       number shown, the running price, and the quantity the Add to
       cart button will send. Never goes below 1. */
    document.addEventListener('click', (event) => {
      const step = event.target.closest('[data-qty-step]');
      if (!step) return;
      const wrap = step.closest('[data-fluff-qty]');
      const card = step.closest('.fm-dialog-card') || document;
      const valueEl = q('[data-qty-value]', wrap);
      const next = Math.max(1, Number(valueEl.textContent || 1) + Number(step.dataset.qtyStep));
      valueEl.textContent = String(next);
      const addButton = q('[data-fluff-add]', card);
      if (addButton) addButton.dataset.quantity = String(next);
      const priceEl = q('[data-qty-price]', card);
      if (priceEl) {
        const unit = Number(priceEl.dataset.unitPrice || 0);
        const currency = window.Shopify?.currency?.active || 'CAD';
        if (unit) priceEl.textContent = money(unit * next, currency);
      }
    });

    // Clicking the dark area around a pop-up closes it. (A click that
    // lands on the <dialog> itself, rather than the white card inside,
    // means the shopper clicked the backdrop.)
    document.addEventListener('click', (event) => {
      if (event.target.tagName === 'DIALOG') event.target.close();
    });

    // Set everything up when the page loads, and again whenever the
    // Theme Editor reloads a section while someone is editing.
    // Snippet bundles can execute before or after DOMContentLoaded depending
    // on Shopify's asset order. Handle both so the wizard is always wired.
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
    else setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));

    // Expose a couple of helpers for other scripts (and for debugging).
    window.FluffMallowsComponents = { setup, addCartItem };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
